import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface PartDetailsPartDocumentsProps {
  partId: number | null;
}

const PartDetailsPartDocumentsComponent: FC<PartDetailsPartDocumentsProps> = ({
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  partId,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      {partId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={partId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const PartDetailsPartDocuments = connect(({ details: { partId } }) => ({ partId }), {
  clearTools,
  getNCFileByPartId,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsPartDocumentsComponent);

export { PartDetailsPartDocuments };
